import React from 'react';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { withEventScope } from '@repo/event-processor';

import BackgroundReplacerTool from 'components/BackgroundReplacer/BackgroundReplacerTool/BackgroundReplacerTool';
import { toPresets } from 'components/BackgroundReplacer/BackgroundReplacerTool/utils';
import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import { ScenesGroup } from 'global/types/Generators';

const BackgroundReplacer: React.FC<
  SliceComponentProps<Content.BackgroundReplacerSlice>
> = ({ slice, context }) => {
  const title = slice.primary.galleryTitle;
  const sceneGroups = (context as { sceneGroups: ScenesGroup[] } | undefined)
    ?.sceneGroups;

  if (!sceneGroups) {
    return null;
  }

  return (
    <ContentWrapper className="background-replacer" customWidth="1116px">
      <BackgroundReplacerTool
        galleryTitle={title ?? undefined}
        presets={toPresets(sceneGroups)}
      />
    </ContentWrapper>
  );
};

export default withEventScope(BackgroundReplacer, {
  module: 'backgroundReplacer',
});
